const AuthLayout = ({ title, subtitle, children, showLogo = false }) => {
  const logoSrc = `${process.env.PUBLIC_URL}/logoNew10.svg`;

  return (
    <div className="row justify-content-center auth-layout">
      <div className="col-lg-6 col-xl-5">
        <div className="card shadow-sm app-card">
          <div className="card-body p-4 p-lg-5">
            {showLogo && (
              <div className="auth-logo text-center mb-5">
                <img src={logoSrc} alt="CrickArena" width={190} />
              </div>
            )}
            <h2 className="h4 mb-1 fw-semibold">{title}</h2>
            {subtitle && <p className="text-muted mb-4">{subtitle}</p>}
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
